import React, {Component} from 'react';
import {Input, InputGroup, InputGroupAddon} from "reactstrap";

class SalaryInput extends Component
{
    constructor(props) {
        super(props);

        let value = props.value

        if (value !== null && value !== '') {
            value = Math.round(value / 1000)
        } else {
            value = undefined
        }

        this.state = { value }
    }

    sendValue = (value) => {
        this.setState({ value })
        if (value !== '')
            value *= 1000
        this.props.onChange({ target: { value } })
    }

    render() {
        return (
            <InputGroup className="input-group-salary">
                <Input
                    min="0"
                    max="240"
                    {...this.props}
                    value={this.state.value}
                    type="number"
                    onChange={e => this.sendValue(e.target.value)}
                />
                <InputGroupAddon addonType="append">
                    <p>K €</p>
                </InputGroupAddon>
            </InputGroup>
        );
    }
}

export default SalaryInput;
